module.exports = __webpack_public_path__ + "static/media/white-logo.3f0be00a.png";